export const SENDING_REQUEST = 'SENDING_REQUEST';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const SET_RESPONSE = 'SET_RESPONSE';
